import { Switch } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';

import type { TimeZonesStore } from '../../../shared/stores/TimeZonesStore';

import styles from './TimezoneSwitch.module.css';

type SwitchProps = {
  timeZones: TimeZonesStore;
  orientation?: 'horizontal' | 'vertical';
};

export const TimezoneSwitch = observer(function TimezoneSwitch({ timeZones, orientation = 'vertical' }: SwitchProps) {
  const userHours = timeZones.userTimeZoneTitle;
  const wellHours = timeZones.wellTimeZoneTitle;

  if (!wellHours) {
    return null;
  }

  function selectTimeZone(value: boolean) {
    if (value) {
      timeZones.select('well');
    } else {
      timeZones.select('user');
    }
  }

  const renderNode = (hours: { isNegative: boolean; wholeHours: number; minutes: number }) => {
    return hours.minutes ? (
      <div className={styles.LabelWithMinutes}>
        <div className="value">
          {hours.isNegative ? '-' : '+'}
          {hours.wholeHours}
        </div>
        <div className="time">:{hours.minutes}</div>
      </div>
    ) : (
      <div className={styles.Label}>
        {hours.isNegative ? '-' : '+'}
        {hours.wholeHours}
      </div>
    );
  };

  return (
    <Switch
      leftNode={renderNode(userHours)}
      rightNode={renderNode(wellHours)}
      style={{ marginLeft: 4 }}
      orientation={orientation}
      size="m"
      checked={timeZones.selected === timeZones.wellTimeZone}
      onChange={(value) => {
        selectTimeZone(value);
      }}
    />
  );
});
